import type { AnalyticsOptions as CoreAnalyticsOptions } from 'owa-analytics-types';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';
import { getHostAppTelemetryEndpoint } from './utils/getHostAppTelemetryEndpoint';
import { ARIA_TENANT_TOKENS } from './utils/constants';

/**
 * The 'owa-analytics' shared package doesn't support telemetry endpoint override.
 * However, host apps (e.g. Outlook Lite) want to override the telemetry endpoint.
 * Hence, we are extending this type here to support overriding of telemetry endpoint.
 * Logic to override the telemetry endpoint would be patched in the 'owa-analytics' package,
 * until we have a better solution.
 */
interface AnalyticsOptions extends CoreAnalyticsOptions {
    getEndpointUrlOverride?: () => string;
}

export default function getMiniAnalyticsOptions(): AnalyticsOptions {
    let getEndpointUrlOverride: () => string;

    // Allow host app to override the telemetry endpoint, if required.
    if (isMiniHostAppFeatureEnabled('loadTelemetryEndpointFromHost')) {
        getEndpointUrlOverride = getHostAppTelemetryEndpoint;
    }

    return {
        ariaTenantTokens: ARIA_TENANT_TOKENS,
        flightControls: {
            client_event: {
                flight: 'mini-ana-client-event',
                rate: 5,
            },
            client_verbose: {
                flight: 'mini-ana-client-verbose',
                rate: 1,
            },
            client_network_request: {
                flight: 'mini-ana-client-network-request',
                rate: 1,
            },
            client_error: {
                flight: 'mini-ana-client-error',
            },
        },
        qosDatapointNames: [
            'MailComposeNew',
            'MailComposeReplyAll',
            'MailComposeReply,',
            'MailComposeForward',
            'MailComposeSend',
            'LoadAccountOption',
            'SaveQuickActionsOption',
            'LoadSignatureOption',
        ],
        getEndpointUrlOverride,
    };
}
